import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';

@Component({
    selector: 'app-footer',
    templateUrl: './app.footer.component.html'
})
export class AppFooterComponent {

    constructor(public layoutService: LayoutService) { }
    version: string;

    ngOnInit() {
        const today = new Date();
        const yyyymmdd = today.getFullYear().toString()
            + ('0' + (today.getMonth() + 1)).slice(-2)
            + ('0' + today.getDate()).slice(-2);

        this.version = `1.6`;
    }

}
